import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';

import { DynamicTableService } from 'src/app/core/services/dynamic-table.service';
import { PrivateNumberPriceFilterFormComponent } from 'src/app/pages/private-number-price/private-numbers-price-for-user/private-number-price-filter-form/private-number-price-filter-form.component';
import { FormFieldSearcherModule } from "../../../../shared/components/form-fields/form-field-searcher/form-field-searcher.module";
import { BaseFormModule } from 'src/app/pages/shared/base/modules/base-form.module';


@Component({
    selector: 'app-package-organizations-filter-form',
    templateUrl: './package-organizations-filter-form.component.html',
    styleUrls: ['./package-organizations-filter-form.component.scss'],
    imports: [BaseFormModule, FormFieldSearcherModule]
})
export class PackageOrganizationsFilterFormComponent extends PrivateNumberPriceFilterFormComponent implements OnInit {

  constructor(
    protected dynamicTableService: DynamicTableService,
  ) {
    super(dynamicTableService);
  }

  ngOnInit(): void {
    this.initForm();
  }

  initForm() {
    this.form = new FormGroup({
      title: new FormControl(''),
      originalPrice: new FormControl(''),
      expirationType: new FormControl(''),
      depositPrice: new FormControl(''),
    });
  }








}
